import '@mantine/carousel/styles.css'
import { Carousel } from '@mantine/carousel'
import { EmblaCarouselProps } from './embla-carousel.types'

const DEFAULT_SPEED = 2.0

export const EmblaCarousel = ({ items, ...props }: EmblaCarouselProps) => (
  <Carousel loop speed={DEFAULT_SPEED} {...props}>
    {items.map(({ id, content }) => (
      <Carousel.Slide key={id}>{content}</Carousel.Slide>
    ))}
  </Carousel>
)
